export enum TimelineState {
    ACTIVE = 0,
    SUSPENDED = 1,
    RETIRED = 2,
}

export const TimelineStates = [
    { id: TimelineState.ACTIVE, name: 'Active' },
    { id: TimelineState.SUSPENDED, name: 'Suspended' },
    { id: TimelineState.RETIRED, name: 'Retired' },
];
